import statistics from '@/locales/en/statistics/statistics.locales';

export default {
    ...statistics,
};
